export const componentClassName = 'placeholder-container';
